import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../theme';
import { AlertMessage } from '../AlertMessage';
import { ButtonBase } from '../Button';
import { Heading } from '../Heading';
import { Paragraph } from '../Paragraph';

export const StyledHeading = styled(Heading)`
    ${({ theme }: { theme: Theme }) => `
        margin-bottom: ${theme.tggSpacing(rem(2), 5)};
        ${theme.breakpoints.up('desktop')} {
            text-align: center;
        }
	`}
`;

export const StyledLink = styled('a')`
    ${({ theme }: { theme: Theme }) => `
        font-weight: bold;
        color: ${theme.palette.primary.dark};
        text-decoration: none;
        & :hover {
            color: ${theme.palette.primary.dark};
        }
	`}
`;

export const StyledAlertMessage = styled(AlertMessage)`
    margin-bottom: ${({ theme }: { theme: Theme }) =>
        theme.tggSpacing(rem(2), 5)};
`;

export const StyledBillingAddressWrapper = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        /* stylelint-disable unit-allowed-list */
        display: flex;
        flex-direction: row;
        align-items: end;
        padding: ${theme.tggSpacing([rem(1.5), rem(1.5)], [3.75, 3.75])};
        background-color: ${theme.palette.grey[100]};
        border-radius: ${theme.tggSpacing(rem(1.6), 6)};

        ${theme.breakpoints.up('desktop')} {
            padding: ${theme.tggSpacing([rem(2.2), rem(2.5)], [9, 6.25])};
            margin: ${theme.tggSpacing([0, rem(5.5)], [0, 20])};
        }
	`}
`;

export const StyledInputInnerWrapper = styled('div')`
    display: grid;
    font-weight: bold;
    text-align: left;
`;

export const StyledParagraph = styled(Paragraph)`
    ${({ theme }: { theme: Theme }) => `
        text-align: left;
        ${theme.breakpoints.up('desktop')} {
            margin: ${theme.tggSpacing([0, rem(5.3)], [0, 20])};
            text-align: center;
        }
	`}
`;

export const StyledButton = styled(ButtonBase)`
    ${({ theme }: { theme: Theme }) =>
        theme.typography.text_14_bold_desktop_16};
    ${({ theme }: { theme: Theme }) => `
        margin: ${theme.tggSpacing([0, 0, 0, 'auto'], [0, 0, 0, 'auto'])};
        
        color: ${theme.palette.primary.dark};

        &:hover {
            color: ${theme.palette.primary.main};
            background: none;
        }
	`}
`;
